import React from "react";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { Reveal, SectionLabel } from "@/components/Reveal";
import { SERVICES } from "@/data/content";

const EASE = [0.16, 1, 0.3, 1];

const Services = () => {
  const { lang, t } = useLang();

  return (
    <section
      id="servizi"
      data-testid="services-section"
      className="relative bg-cream text-forest py-24 sm:py-32 lg:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-14">
        <div className="grid lg:grid-cols-12 gap-8 items-end mb-16">
          <div className="lg:col-span-8">
            <SectionLabel>{t("services.label")}</SectionLabel>
            <Reveal delay={0.1}>
              <h2 className="font-display font-light tracking-tight leading-[1.02] text-4xl sm:text-5xl lg:text-6xl mt-6 max-w-3xl">
                {t("services.title")}
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-4">
            <Reveal delay={0.2}>
              <p className="text-forest/70 font-light leading-relaxed">
                {t("services.intro")}
              </p>
            </Reveal>
          </div>
        </div>

        <div className="max-w-4xl">
          {/* List (images removed by client request) */}
          <div>
            {SERVICES.map((s, i) => (
              <motion.div
                key={s.id}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, ease: EASE, delay: i * 0.05 }}
                className={`group border-t border-forest/15 py-8 lg:py-10 cursor-default transition-colors duration-300 ${
                  i === SERVICES.length - 1 ? "border-b" : ""
                }`}
                data-testid={`service-${s.id}`}
              >
                <div className="flex items-start gap-5 lg:gap-8">
                  <span className="font-display text-xl text-gold-2 pt-1 shrink-0">{s.num}</span>
                  <div className="flex-1">
                    <div className="flex items-start justify-between gap-4">
                      <h3 className="font-display text-3xl sm:text-4xl lg:text-[2.6rem] font-medium tracking-tight leading-tight group-hover:text-forest-deep transition-colors">
                        {s[lang].title}
                      </h3>
                      <Plus
                        className="text-forest/40 mt-2 shrink-0 group-hover:rotate-90 group-hover:text-gold-2 transition-all duration-500"
                        size={22}
                      />
                    </div>
                    <p className="text-forest/70 font-light leading-relaxed mt-3 max-w-2xl">
                      {s[lang].text}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
